export default __webpack_public_path__ + "static/econ-image-813e9369b8c0f3c9488806d13f237153.png";